export default __webpack_public_path__ + "static/media/LO13.1.3da43496.mp3";